import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { SCAN_CREATE } from "./gql";

const useScanCreate = createDefaultMutationHook(SCAN_CREATE);

export default useScanCreate;
